import { useEffect, useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import CartContext from '../../store/cart-context';
import CartProvider from '../../store/CartProvider';

import Price from '../UI/Price';
import Header from '../../components/Layout/Header';
import Cart from '../../components/Cart/Cart';

function CartFooter() {
  const navigate = useNavigate();
  const cartContext = useContext(CartContext);

  if( cartContext.showFooter && cartContext.items.length > 0 ){
    const itemsAmount = cartContext.items.reduce((curr, item) => {
      return curr + (item.products.length);
    }, 0);

    return (
      <div className='cart-footer fixed-bottom bg-white d-flex'>
        <div className='w-50 text-center'>
          {itemsAmount} {itemsAmount > 1 ? 'productos' : 'producto'}<br />
          <strong>
            <Price value={cartContext.totalAmount} />
          </strong>
        </div>
        <button className='rounded-5 text-white px-3 border-0 mx-auto' onClick={() => navigate('/order')}>Ver Pedido</button>
      </div>
    );
  }else
    return (<></>);
}

function AppLayout() {
  const cartContext = useContext(CartContext);
  const [showCart, setShowCart] = useState(false);

  const showCartHandler = () => {
    setShowCart(true);
  };

  const hideCartHandler = () => {
    setShowCart(false);
  };

  useEffect(() => {
    document.body.className = 'app';
  }, []);

  return (
    <CartProvider>
      {showCart && <Cart onHideCart={hideCartHandler} />}
      <Header onShowCart={showCartHandler} />
      <main style={{ marginBottom: cartContext.showFooter ? '60px' : '' }}>
        <Outlet />
      </main>
      <CartFooter />
    </CartProvider>
  );
}

export default AppLayout;
